// @flow
export const API_BASE =
  process.env.REACT_APP_RM_ENV && process.env.REACT_APP_RM_ENV === 'prod'
    ? 'https://livecms.roymorgan.com'
    : 'https://livecms.roymorganuat.com';
